module.exports = __webpack_public_path__ + "static/media/icon-duration-finance.c7859987.svg";